import { gsap } from 'gsap'

export const flip = <T extends HTMLElement & { _flip?: GSAPTimeline }>(
  elements: T | T[],
  changeFunc: () => void,
  vars: GSAPTweenVars = {}
) => {
  const gsapElements = gsap.utils.toArray<T>(elements)
  const tl = gsap.timeline({
    onComplete: vars.onComplete,
    delay: typeof vars.delay === 'string' ? parseInt(vars.delay) ?? 0 : 0,
  })
  const bounds = gsapElements.map((el) => el.getBoundingClientRect())
  const varsCopy = {} as GSAPTweenVars

  gsapElements.forEach((el) => {
    if (el._flip) el._flip.progress(1)
    el._flip = tl
  })
  changeFunc()
  for (const p in vars) {
    p !== 'onComplete' && p !== 'delay' && (varsCopy[p] = vars[p])
  }
  varsCopy.x = (i, element) =>
    '+=' + ((bounds[i]?.left as number) - element.getBoundingClientRect().left)
  varsCopy.y = (i, element) =>
    '+=' + ((bounds[i]?.top as number) - element.getBoundingClientRect().top)

  return tl.from(elements, varsCopy)
}
